export enum OrderMode {
    userProvided = 'user_provided',
    shuffle = 'shuffle'
}

export const defaultOrderMode = OrderMode.userProvided
